<template>
  <el-dialog
    left
    :title="title"
    :closeOnClickModal="false"
    :closeOnPressEscape="false"
    :showClose="true"
    width="450px"
    @close="handleCancel()"
    style="margin: 0 auto;"
    :visible.sync="isShow"
    class="contactMdl col-lg-12 col-sm-12 col-12 col-md-12"
  >
    <form @submit.prevent="contactSave">
      <div class="row">
        <div class="col-12">
          <div>
            Name
            <span class="required">*</span>
          </div>
          <input
            type="text"
            class="form-control team-form"
            v-model="value.data.name"
            required
            placeholder="Name"
          />
        </div>
      </div>
      <div class="row" v-if="title != 'Edit Contact'">
        <div class="col-12">
          <div style="margin-bottom:5px">
            Company
            <span class="required">*</span>
          </div>
          <vue-bootstrap-typeahead
            :data="portfolioAll"
            v-model="company_name"
            v-if="value.isShow"
            :serializer="usersSerializer"
            :minMatchingChars="minMatchingChars"
            placeholder="Enter Referred by"
            @hit="onAfterUserSelection"
          >
            <template slot="suggestion" slot-scope="{ data }">
              <div class="d-flex">
                <div v-if="data.logo_url" style="margin-right:10px">
                  <img :src="data.logo_url" class="companyImageCls" />
                </div>
                <div style="margin-top:auto;margin-bottom:auto">{{data.name}}</div>
              </div>
            </template>
          </vue-bootstrap-typeahead>
        </div>
      </div>
      <div class="row" style="margin-top: 15px;margin-bottom: 18px;" v-if="title != 'Edit Contact'">
        <div class="col-6">
          <div class="d-flex">
            <input
              type="checkbox"
              v-model="value.data.isInvestor"
              class="regular-checkbox"
              style="margin-right:15px"
            />
            <div>Investor</div>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex" style="margin-right:15px">
            <input
              type="checkbox"
              v-model="value.data.isFounder"
              class="regular-checkbox"
              style="margin-right:15px"
            />
            <div>Founder</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div>
            Email
            <span class="required">*</span>
          </div>
          <input
            type="email"
            class="form-control team-form"
            v-model="value.data.email"
            required
            placeholder="Email"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div>Phone number</div>
          <input
            type="number"
            class="form-control team-form"
            v-model="value.data.phone_number"
            placeholder="Phone number"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div>Linkedin URL</div>
          <input
            type="email"
            class="form-control team-form"
            v-model="value.data.url_linkedin"
            placeholder="Linkedin URL"
          />
        </div>
      </div>
      <div class="edit-company-action-button-row pt-3" style="margin:0px">
        <button
          type="button"
          @click="handleCancel()"
          class="todo-form-cancel-button btn-outline-secondary"
        >Cancel</button>
        <!-- || !checkSubmit -->
        <button
          type="submit"
          :disabled="submitted "
          class="todo-form-submit-button btn btn-primary"
          style="height: 35px;"
        >
          Save
          <b-spinner v-if="submitted" style="float: right;" small label="Loading..."></b-spinner>
        </button>
      </div>
    </form>
  </el-dialog>
</template>
<script>
import { Select, Option, Dialog } from "element-ui";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { mapGetters } from "vuex";
import { json } from "d3";
import api from "../../../axios_api";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    VueBootstrapTypeahead
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioAll"]),
    checkSubmit() {
      let check = false;
      if (
        (this.value.data.isInvestor || this.value.data.isFounder) &&
        this.value.data.name &&
        this.value.data.email &&
        this.value.data.company &&
        this.company_name.length > 0 &&
        this.value.data.company._id
      )
        check = true;
      return check;
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      }
    },
    title: {
      get() {
        return this.value.isCreate ? "Add Contact" : "Edit Contact";
      }
    }
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
      isCreate: Boolean
    }
  },
  data() {
    return {
      submitted: false,
      minMatchingChars: 1,
      company_name: ""
    };
  },
  methods: {
    onAfterUserSelection(selectedValue) {
      if (selectedValue && selectedValue._id) {
        this.value.data.company = selectedValue;
      }
    },
    usersSerializer(data) {
      return data.name;
    },
    handleCancel() {
      this.value.isShow = false;
      this.submitted = false;
    },
    contactSave() {
      let self = this;
      this.submitted = true;
      let payload = JSON.parse(JSON.stringify(this.value.data));
      if (this.value.isCreate) {
        payload.context = [];
        if (payload.isInvestor) payload.context.push("investor");
        if (payload.isFounder) payload.context.push("founder");
        self.$store
          .dispatch("contacts/apiPostContact", payload)
          .then(data => {
            self.$toaster.success("Successfully Contact created.");
            self.handleCancel();
          })
          .catch(err => {
            self.$toaster.error("Fail to save contact");
            self.submitted = false;
            console.log("Fail to insert contact data", { err });
          });
      } else {
        self.$store
          .dispatch("contacts/apiPatchContact", payload)
          .then(data => {
            self.$toaster.success("Successfully Save.");
            self.$parent.tabulator.updateData([payload]);
            self.handleCancel();
          })
          .catch(err => {
            self.$toaster.error("Fail to update contact");
            self.submitted = false;
            console.log("Fail to insert contact data", { err });
          });
      }
    }
  }
};
</script>
<style>
.companyImageCls {
  min-width: 100%;
  min-height: 100%;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
</style>